"use client"

import { ComponentConfig } from "@measured/puck"
import dayjs from "dayjs"
import { useEffect, useState } from "react"
import "swiper/css"
import "swiper/css/pagination"
import { twMerge } from "tailwind-merge"
import { formatDate } from "../../../../../../utils/formatDate"
import { generateImagePath } from "../../../../../../utils/generateImagePath"
import { fetchPostId } from "../../../../../post/services/post"
import { configs, DefaultImage } from "../../../../external-components"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../../lib/helper"
import { PostData, TagData } from "../../../types"
export interface ArticleItem {
  image1?: string
  image2?: string
  time?: Date
  itemTitle?: string
  excerpt?: string
  tags?: TagData
}

export interface ArticlesProps extends CommonStylesProps {
  type: "fluid" | "custom" | "boxed"
  gapCustom?: string
  heightContact?: string
  category?: { post?: number }
}

export const RenderSinglePost: ComponentConfig<ArticlesProps> = {
  render: ({ className, category, styles, gapCustom, responsiveType }) => {
    const id = `navigation-${Math.random().toString(36).substr(2, 9)}`
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)
    const [singleArticle, setSingleArticle] = useState<PostData>()

    const formattedDate = (date: string | Date) => {
      return dayjs(date).format("MMM D, YYYY")
    }

    const fetchPost = async (postId: number) => {
      if (category?.post !== undefined) {
        const responsePost = await fetchPostId(category.post)

        setSingleArticle(responsePost)
      } else {
        console.log("Post ID is undefined")
      }
    }
    useEffect(() => {
      if (category?.post !== undefined) {
        fetchPost(category?.post)
      }
    }, [category])

    return (
      <>
        {responsiveCSS}
        <div id={id} className={twMerge(className, "w-full max-w-[1440px] flex justify-center")}>
          <div className="w-full flex lg:flex-row flex-col lg:gap-16 gap-6">
            <img
              src={generateImagePath(singleArticle?.attributes.image.data?.attributes.url, "medium") || DefaultImage}
              alt=""
              className="rounded-2xl lg:w-[543px] w-[343px] h-[327px] object-cover"
            />
            <div className="flex flex-col gap-4">
              <div className="flex flex-row gap-2 items-center">
                {singleArticle?.attributes.tags.data?.map((tag, index) => (
                  <p
                    key={index}
                    className="py-1.5 px-2 rounded-lg bg-[#0B9444] text-white uppercase text-sm font-semibold"
                    style={{ lineHeight: "16px" }}
                  >
                    {tag.attributes.name}
                  </p>
                ))}
                <p className="text-[#999999] text-sm">
                  •{" "}
                  {singleArticle?.attributes.createdAt
                    ? formattedDate(singleArticle?.attributes.createdAt)
                    : "Date not available"}
                </p>
              </div>
              <h2 className="text-[#242F3E] font-semibold lg:text-[32px] text-[28px] lg:leading-10 leading-7">
                {singleArticle?.attributes.name}
              </h2>
              <p
                className="text-[#4F4F4F] lg:text-xl leading-6 text-lg"
                dangerouslySetInnerHTML={{ __html: singleArticle?.attributes.excerpt || "" }}
              />
              <div className="w-full flex flex-row items-center justify-between pb-4 border-b border-[#EBEDF0]">
                <p className="text-[#999999] text-sm">
                  {singleArticle?.attributes.createdAt
                    ? formatDate(singleArticle?.attributes.createdAt).formattedDate
                    : "Date not available"}
                </p>
                <a href={`${configs.API_URL}/${singleArticle?.attributes.slug}`} className="text-[#0B9444] text-sm">
                  Read more
                </a>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  },
}
